import * as React from 'react';
export const SvgFiletypeWord = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', ...props },
        React.createElement("path", { d: 'M11 3V0H2v16h12V3z', fill: '#6bbae8' }),
        React.createElement("path", { d: 'M10.7 6.05H12L9.3 12H7.95L7.7 7.5l-2 4.5H4.3L4 6h1.35l.05 4.6 2-4.6h1.35l.2 4.65z', fill: '#fff' }),
        React.createElement("path", { d: 'M11 0l3 3h-3z', fill: '#4d83a1' })));
};
export default SvgFiletypeWord;
